import { FloorMasterCleaningSchedule } from 'pdfs/master-cleaning-schedule-report';
import { EZoneTargetCleaningType } from '../../enums';

export const floorsMasterCleaningScheduleMock: FloorMasterCleaningSchedule[] = [
  {
    title: 'Floor 1',
    zones: [
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
    ],
  },
  {
    title: 'Floor 2',
    zones: [
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
    ],
  },
  {
    title: 'Floor 3',
    zones: [
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
    ],
  },
  {
    title: 'Floor 4',
    zones: [
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.FREQUENCY,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
      {
        type: EZoneTargetCleaningType.SCHEDULE,
        code: '171714',
        location: 'Fitness Center',
        interval: 'daily',
        frequency: 1,
        cleaningTimes: ['08:00 AM', '10:00 AM'],
      },
    ],
  },
];
